"use client"

import Title from "@/components/common/Typography/Title"
import { Col, Row, Skeleton } from "antd"
import { useTranslation } from "react-i18next"
import HotelGoodPricesMobileSkeleton from "./index.mobile.skeleton"

const HotelGoodPricesCRSSkeleton = () => {
  const { t } = useTranslation()

  return (
    <Row style={{ marginBottom: '3rem' }}>
      <Col span={24}>
        <Row style={{ marginBottom: '1rem' }}>
          <Title
            level={3}
            style={{
              margin: 0,
              marginBottom: '0.5rem'
            }}
          >
            {t("hotel.goodprices_title")}
          </Title>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[5, 5]} style={{ marginBottom: '1rem' }}>
          {Array(8).fill(null).map((_, idx) => {
            return (
              <Col key={idx}>
                <Skeleton.Button
                  shape='round'
                  size='small'
                  active
                  style={{
                    minWidth: '10rem',
                    height: '3.2rem'
                  }}
                />
              </Col>
            )
          })}
        </Row>
      </Col>
      <Col span={24}>
        <HotelGoodPricesMobileSkeleton />
      </Col>
    </Row>
  )
}

export default HotelGoodPricesCRSSkeleton